import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DenySessionPage from "@/pages/DenySessionPage";
import DashboardPage from "@/pages/DashboardPage";
import SettingsPage from "@/pages/SettingsPage";
import AydinlatmaMetni from "@/pages/AydinlatmaMetni";
import GizlilikPolitikasi from "@/pages/GizlilikPolitikasi";
import KullanimSartlari from "@/pages/KullanimSartlari";
import CerezPolitikasi from "@/pages/CerezPolitikasi";
import CookieConsent from "@/components/CookieConsent";
import "@/App.css";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen grid place-items-center bg-white text-zinc-500 text-sm">
        Yükleniyor...
      </div>
    );
  }
  if (!user) return <Navigate to="/giris" replace />;
  return children;
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <CookieConsent />
          <Routes>
            <Route path="/giris" element={<LoginPage />} />
            <Route path="/kayit" element={<RegisterPage />} />
            <Route path="/sifremi-unuttum" element={<ForgotPasswordPage />} />
            <Route path="/sifre-sifirla" element={<ResetPasswordPage />} />
            <Route path="/oturum-reddet" element={<DenySessionPage />} />
            <Route path="/aydinlatma" element={<AydinlatmaMetni />} />
            <Route path="/gizlilik" element={<GizlilikPolitikasi />} />
            <Route path="/kullanim" element={<KullanimSartlari />} />
            <Route path="/cerez" element={<CerezPolitikasi />} />
            <Route
              path="/ayarlar"
              element={
                <Protected>
                  <SettingsPage />
                </Protected>
              }
            />
            <Route
              path="/"
              element={
                <Protected>
                  <DashboardPage />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
